module.exports = {
          srcSet: __webpack_public_path__ + "fc09d04d.jpg"+" 700w"+","+__webpack_public_path__ + "089c412b.jpg"+" 1400w"+","+__webpack_public_path__ + "93b6de30.jpg"+" 2048w",
          images:[ {path: __webpack_public_path__ + "fc09d04d.jpg",width: 700,height: 467},{path: __webpack_public_path__ + "089c412b.jpg",width: 1400,height: 933},{path: __webpack_public_path__ + "93b6de30.jpg",width: 2048,height: 1365}],
          src: __webpack_public_path__ + "fc09d04d.jpg",
          toString:function(){return __webpack_public_path__ + "fc09d04d.jpg"},
          
          width: 700,
          height: 467
        }